var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.5,
    clipRule: "evenodd",
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "stroke fill",
    d: "M44.036 69.802V54.121a3 3 0 0 1 3-3H62.52"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    className: "stroke",
    d: "M42.769 69.985a6.98 6.98 0 0 0 5.179-2.287l13.369-14.734a6.97 6.97 0 0 0 1.809-4.685V9.517a4.446 4.446 0 0 0-4.442-4.446l-42.366-.033a4.446 4.446 0 0 0-4.449 4.441l-.064 55.997a4.444 4.444 0 0 0 4.435 4.45zM26.327 51.121h-5.69M36.158 56.725H20.637M28.397 62.125h-7.76"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "stroke fill",
    d: "M35.202 17.898c-7.456 0-13.5 6.045-13.5 13.501 0 5.536 3.338 10.298 8.11 12.38a13.4 13.4 0 0 0 5.39 1.121c7.456 0 13.501-6.045 13.501-13.501H35.202z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    className: "stroke",
    d: "M53.298 25.49c0-6.731-5.456-12.187-12.187-12.187V25.49z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.7922dfa3019795df6188b050086087e8.svg";
export { ForwardRef as ReactComponent };